import "rsuite/dist/rsuite.min.css";
import React, { useEffect, useState, useContext, useRef ,Fragment} from "react";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import "../main.css";
import Layout from "components/sales/layout/layout";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ModalPop from "components/sales/modal/modal";
import Multiselect from 'multiselect-react-dropdown';
import ReactPaginate from "react-paginate";
import { toast } from 'react-toastify';
import ListFilters from "components/sales/ListFilters/ListFilters";

const EventSalary = ({
  history,
  getValetEventSalary,
  approveValetEventSalary,
  eventSalaryList=[],
  approveSalary=[],
  match,
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isChecked, setIsChecked] = useState([false]);
  const [isFreezeModal, setIsFreezeModal] = useState(false);
  const [isCalculateModal, setIsCalculateModal] = useState(false);
  const [error, setError] = useState("");
  const [isModalFailed, setIsModalFailed] = useState(false);
  const [calculateSalaryModal, setCalculateSalaryModal] = useState(false);
  const [dailySalaryModal, setDailySalaryModal] = useState(false);
  const [freezeId, setFreezeId] = useState(false);
  const [inputFields, setInputFields] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      var res=await getValetEventSalary(1,null);
      if (res && res?.resultSets && Object.keys(res).length > 0 ) {
        setInputFields(res?.resultSets)
      }
      setIsLoading(false);
    })();
  }, [getValetEventSalary]);

//   const handleDailySalaryDistribution = async (
//     montlySalaryId,
//     userName,
//     status
//   ) => {
//     const payload = {
//       valet_monthly_salary_id: montlySalaryId,
//       user_name: userName,
//       status: status,
//     };
//     setIsLoading(true);
//     await dailyValetSalaryDistribution(payload);
//     setDailySalaryModal(payload?.valet_monthly_salary_id);
//     setIsLoading(false);
//     return false;
//   };

  const handleCalculate = async (id,index) => {
    const updatedFields = [...inputFields];

    const payload = {
      approved_salary: updatedFields[index]?.approved_salary,
      valet_event_salary_id: id,
    };
    setIsLoading(true);
    const res = await approveValetEventSalary(payload);
    if (res.status) {
      setCalculateSalaryModal(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

//   const handleCalculateFreeze = async (salaryId) => {
//     const payload = {
//       monthly_salary_record_id: [salaryId],
//       status: "OPS_FREEZED",
//     };
//     setIsLoading(true);
//     const res = await updateSalaryStatusForValet(payload);
//     if (res.status) {
//       toast.success("Salary freezed successfully!");
//       history.push('/dashboard/salary-master');  
//     } else {
//       toast.error("Failed to freeze salary!");
//       history.push('/dashboard/salary-master');
//     }
//     setIsLoading(false);
//   };
  
  const handleCalculateModalHide = () => {
    setIsCalculateModal(false);
    setError(""); 
    window.location.reload();
  };

  const handlesetCalculateSalaryModalHide = () => {
    setCalculateSalaryModal(false);
    window.location.reload();
  };

  const handleFreezeModalHide = () => {
    setIsFreezeModal(false);
    setError("");
    window.location.reload();
  };

  
  const handleFailedModalHide = () => {
    setIsModalFailed(false);
    setError(""); 
    window.location.reload();
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getValetEventSalary(val.selected + 1, null);
    setIsLoading(false);
  };

  const handleDailyModalCloseClick = () => {
    setDailySalaryModal(false);
    window.location.reload();
  };

  useEffect(() => {
    setIsLoading(true);
    setPageCount(Math.ceil(eventSalaryList.total / eventSalaryList.per_page));
    setIsLoading(false);
  }, [eventSalaryList] )


  const handleInputChange = (field, value, index) => {
    const updatedFields = [...inputFields];
    updatedFields[index][field] = value;
    setInputFields(updatedFields);
  };  
  
  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {" "}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("event_salary_filter", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    var res=await getValetEventSalary(1, filterData);
    if (res && res?.resultSets && Object.keys(res).length > 0 ) {
        setInputFields(res?.resultSets)
      }else{
        setInputFields([])
      }
    setIsLoading(false);
    filterToggle();
  };
return (
    <>
      <Layout
        title={localization.eventSalary}
        isGoback
        isLoading={isLoading}
        Buttons={headerBtns}
      >
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
        />
        <>
          {eventSalaryList && eventSalaryList?.resultSets &&  eventSalaryList?.resultSets?.length > 0 ? (
            <>
            <div className="cdx" style={{ overflowX: "auto" }}>
              <table className="monthly-salary-table">
                <thead className="fix-head">
                  <tr className="table-heading v3Tab monthly-table-row">
                    <th className="monthly-table-head fx-tab">S.No.</th>
                    <th className="monthly-table-head fx-tab">Driver name</th>
                    <th className="monthly-table-head">Phone Number</th>
                    <th className="monthly-table-head">Project ID</th>
                    <th className="monthly-table-head">Start Date</th>
                    <th className="monthly-table-head">
                      End Date
                    </th>
                    <th className="monthly-table-head">Total Working Hours</th>
                    <th className="monthly-table-head">
                      Monthly Salary
                    </th>
                    <th className="monthly-table-head">Approved Salary</th>
                    
                    <th className="monthly-table-head">
                      Incentive Wallet Request ID
                    </th>
                    <th className="monthly-table-head">Status</th>
                    <th className="monthly-table-head">Approve</th>

                  </tr>
                </thead>
                <tbody>
                  { eventSalaryList?.resultSets?.map((item, index) => (
                    <>
                      <tr className="monthly-table-row" key={index}>
                      <td className="monthly-table-data fx-tab-2">
                        <b>
                        {parseInt(eventSalaryList?.current_page) === 1 ? index+1 + '.' : 15*(parseInt(eventSalaryList?.current_page)-1)+(1+index)+'.'}
                        </b>
                      </td>
                        <td className="monthly-table-data fx-tab-2">
                          {item?.user_name}
                        </td>
                        <td className="monthly-table-data">
                          {item?.phone_number}
                        </td>
                        <td className="monthly-table-data">
                          {item?.project_id}
                        </td>
                        <td className="monthly-table-data">
                          {item?.start_date ? new Date(item.start_date).toLocaleDateString('en-GB') : '-'}
                        </td>
                        <td className="monthly-table-data">
                          {item?.end_date ? new Date(item.end_date).toLocaleDateString('en-GB') : '-'}
                        </td>
                        <td className="monthly-table-data">
                          {item?.total_work_hours}
                        </td>
                        <td className="monthly-table-data">
                          {item?.monthly_salary}
                        </td>
                        <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={item?.approved_salary}
                            handleChange={(value) => handleInputChange('approved_salary', value, index)}
                            disabled={
                              item.status!="SYSTEM_CALCULATED"
                              && item.status!="FINANCE_MODIFICATION_REQUESTED"
                            }
                          />
                        </td>
                        <td className="monthly-table-data">
                          {item.valet_incentive_wallet_request_id}
                        </td>
                        
                        <td className="monthly-table-data">
                          {item?.status}
                        </td>
                        <td>
                          {(item.status=="SYSTEM_CALCULATED" || item.status=="FINANCE_MODIFICATION_REQUESTED") && (
                              <i
                                className="fa fa-check icon-styling-v1"
                                data-toggle="modal"
                                onClick={() => handleCalculate(item.id,index)}
                              ></i>
                            )}
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
              <div className="d-flex" style={{fontSize:"large", justifyContent:"end"}}>
                <ReactPaginate
                  nextLabel=">"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  previousLabel="<"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  forcePage={eventSalaryList?.currentPage}
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </div>
            </>
          ) : (
            <div>
              <img src={Images?.NoData} alt="" width="100%" />
            </div>
          )}
        </>

        <ModalPop
          title={"Salary Approved!"}
          show={calculateSalaryModal}
          handleModalHide={handlesetCalculateSalaryModalHide}
        >
          <div className="text-center">
            <div className="success">
                <img src={Images?.tick} alt="" />
            </div>
              <h5>{"Salary Calculated Successfully"}</h5>
          </div>

          <Button
            variant="secondary"
            onClick={handlesetCalculateSalaryModalHide}
          >
            OK
          </Button>
        </ModalPop>

        <ModalPop
          title={"Success"}
          show={isCalculateModal}
          handleModalHide={handleCalculateModalHide}
        >
          {error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{"Salary Approved Successfully"}</h5>
            </div>
          )}
          <Button variant="secondary" onClick={handleCalculateModalHide}>
            OK
          </Button>
        </ModalPop>

        <ModalPop
          title={"Failed"}
          show={isModalFailed}
          handleModalHide={handleFailedModalHide}
        >
          {error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="text-center">
              <div className="failed">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{"Something went wrong"}</h5>
            </div>
          )}
          <Button variant="secondary" onClick={handleFailedModalHide}>
            OK
          </Button>
        </ModalPop>

        <ModalPop
          title={localization.conf}
          show={isFreezeModal}
          handleModalHide={handleFreezeModalHide}
          keyboard
          backdrop
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{"Are you sure to the freeze salary?"}</h5>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Button
                onClick={handleFreezeModalHide}
                className="btn btn-danger btn-sm mb-4"
              >
                {localization.no}
              </Button>
              <Button
                // onClick={() =>
                //   handleCalculateFreeze(freezeId)
                // }
                className="btn btn-success btn-sm mb-4"
              >
                {localization.yes}
              </Button>
            </div>
          </div>
        </ModalPop>
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          eventSalaryFilter={true}
          localstorageKey={"event_salary_filter"}
        />
      </Layout>
    </>
  );
};
export default EventSalary;